/* Collapsed variant list: show the selected value, open the rest on demand. */
(function () {
  if (window.t4sSwatchCollapse) return;
  window.t4sSwatchCollapse = true;

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('[data-swatch-more]');
    if (!btn) return;

    var option = btn.closest('.t4s-swatch__option');
    if (!option) return;

    evt.preventDefault();
    var isExpanded = option.classList.toggle('is--expanded');
    var label = isExpanded ? btn.dataset.textLess : btn.dataset.textMore;
    if (label) btn.textContent = label;
    btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
  });
})();
